// src/utils/hooks/useFacilityIdManager.ts
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFacilityIds, getConfigurationFacility } from "../../app/store/config/configActions";
import { State } from "../../app/store";
import { getStepSaleConfig } from "../../app/store/stepSaleConfig/saleStepConfigActions";

export function useFacilityIdManager() {
  const dispatch = useDispatch();
  const configuration = useSelector((state: State) => state.config.configuration);

  useEffect(() => {
    // Function to get facility ID from URL
    const getFacilityIdFromUrl = () => {
      const queryParams = new URLSearchParams(window.location.search);
      return queryParams.get("id");
    };

    // Function to handle facility ID
    const handleFacilityId = async () => {
      try {
        const urlFacilityId = getFacilityIdFromUrl();

        if (urlFacilityId) {
          dispatch(updateFacilityIds(urlFacilityId));
          sessionStorage.setItem("facilityId", urlFacilityId);

          // Fetch configuration if not already loaded
          if (!configuration || Object.keys(configuration).length === 0) {
            await dispatch(getConfigurationFacility(urlFacilityId));
            await dispatch(getStepSaleConfig(urlFacilityId));
          }
        } else {
          const storedFacilityId = sessionStorage.getItem("facilityId");
          if (storedFacilityId) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set("id", storedFacilityId);
            window.history.replaceState({}, "", newUrl.toString());
            dispatch(updateFacilityIds(storedFacilityId));

            // Fetch configuration if not already loaded
            if (!configuration || Object.keys(configuration).length === 0) {
              await dispatch(getConfigurationFacility(storedFacilityId));
              await dispatch(getStepSaleConfig(storedFacilityId));
            }
          }
        }
      } catch (error) {
        console.error("Error handling facility ID:", error);
      }
    };

    handleFacilityId();

    const handlePopState = () => {
      handleFacilityId();
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [dispatch, configuration]);
}
